"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientEmitter = void 0;
exports.ClientEmitter = {
    events: {},
    subscribe: function (str, listener) {
        var _this = this;
        if (!this.events[str])
            this.events[str] = [];
        this.events[str].push(listener);
        return {
            unsubscribe: function () {
                if (!_this.events[str])
                    return;
                _this.events[str].splice(_this.events[str].indexOf(listener) >>> 0, 1);
            }
        };
    },
    reset: function () {
        this.events = {};
    },
    publish: function (str) {
        var message = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            message[_i - 1] = arguments[_i];
        }
        if (!this.events[str])
            return;
        this.events[str].forEach(function (fun) {
            fun.apply(void 0, message);
        });
    }
};
